export default {"src":"/_next/static/media/AMH.c723c9cd.svg","height":18,"width":18};